import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function AdminRoute({ children }) {
  const authCtx = useContext(AuthContext);
  if (authCtx.userId && authCtx.role === "Admin")
    return authCtx.isAuthenticated ? children : <Navigate to="/login" />;
  else {
    return (
      <div>
        <p>Cargando</p>
      </div>
    );
  }
}

export default AdminRoute;
